import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  wrapper: {
    marginTop: 16
  },
  inputLabel: {
    marginBottom: 5
  }
}))
